import React from 'react';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import MenuManualListFP from '../FullPagesComponents/Services/Recipient/MenuManualListFP';

//= ========================================================================
const TransferMethodDF = ({
  globJSON,
  simPlatform,
  recipient,
  slideshowRefs,
}) => (
  <SimulatorsViewerArrangement>
    <MenuManualListFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      recipient={recipient}
      slideshowRefs={slideshowRefs}
    />
  </SimulatorsViewerArrangement>
);

export default TransferMethodDF;
